import React, { useState } from 'react'

import './style.scss'
import { useLayout } from './../../../context/Layout'
import { Icon } from './../../Layout'

import Parser from 'html-react-parser';


function Table({ thead, tbody, onEditar, onDelete, nofileimage }) {

    const { loadFull } = useLayout()

    function ButtonEditar({ onClick, disabled = false }) {

        return (
            <button onClick={onClick} disabled={disabled} title="Editar">
                <i className="fas fa-pen"></i>
            </button>
        )
    }

    function ButtonDeletar({ onClick, disabled = false }) {

        const [deletaValida, setDeletaValida] = useState(false)

        function onValidaDelete() {

            setDeletaValida(true)

            setTimeout(() => {
                setDeletaValida(false)
            }, 2000)
        }

        return (
            <>
                {
                    !deletaValida ?
                        <button disabled={disabled} onClick={onValidaDelete} title="Excluir">
                            <i className="far fa-trash-alt"></i>
                        </button> :
                        <button disabled={disabled} onClick={onClick} className="text-danger" title="Confirmar Exclusão">
                            <i className="fas fa-check"></i>
                        </button>
                }

            </>
        )
    }

    return (
        <>
            {
                <table className="table">

                    <thead className='thead-light'>
                        <tr>
                            {
                                thead.map((head, index) => {

                                    const style = head.tamanho ? { width: head.tamanho } : {}
                                    // Hide on small screens if not first column, simplistic approach kept from original
                                    const className = index === 0 ? '' : 'd-none d-sm-table-cell'

                                    return <th key={index} className={className} style={style}>{head.nome}</th>
                                })
                            }
                            <th className="text-center" style={{ width: 100 }}>AÇÕES</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            tbody.map((tr, index) => {

                                let showButtonEditar = tr.showEdit ? tr.showEdit : false
                                let showButtonDelete = tr.showDelete ? tr.showDelete : false

                                return (
                                    <tr key={index}>
                                        {
                                            tr.dados.map((td, idx) => {

                                                let content = td
                                                const isImage = typeof td === 'string' && (td.trim().startsWith('http') || td.trim().startsWith('data:image'));

                                                if (isImage) {
                                                    content = (
                                                        <div className="cell-avatar">
                                                            <img src={td} alt="Avatar" />
                                                        </div>
                                                    )
                                                } else if (td) {
                                                    content = Parser(String(td))
                                                }

                                                // Special styling for "Criado por" if it matches the pattern (Avatar column + Name column)
                                                // Note: The original code rendered them as separate TDs.
                                                // If we want to combine them, we'd need to change the data structure or Logic here.
                                                // For now, let's keep the existing column mapping but style the image column better.

                                                const className = `${idx === 0 ? '' : 'd-none d-sm-table-cell'} ${isImage ? 'td-avatar' : ''}`.trim()

                                                return (
                                                    <td key={idx} className={className}>
                                                        {content}
                                                    </td>
                                                )
                                            })
                                        }
                                        <td className="text-center">
                                            <div className="cell-actions">
                                                {
                                                    <ButtonEditar
                                                        disabled={!showButtonEditar}
                                                        onClick={() => onEditar(tr.id, showButtonEditar)}
                                                    />
                                                }
                                                {
                                                    showButtonDelete &&
                                                    <ButtonDeletar
                                                        onClick={() => onDelete(tr.id)}
                                                    />
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table >
            }
            {
                tbody.length === 0 && !loadFull &&
                <div className="nofilestable">
                    <img src={`../assets/images/nofiles/${nofileimage ? nofileimage : 'nofile-table.svg'}`} />
                </div>
            }
        </>
    )
}

export default Table